import useBreakpoint from "../../../../shared/hook/useBreakpointHook";

export const useModelViewerBreakpoint = () => {
  const { isDesktop } = useBreakpoint();
  const showAdvancedView = isDesktop();

  return [showAdvancedView];
};
